import { IColumnValidator, IValidationResult } from "@schemas/excelImportSchema";

export const tableArrayToObjectArray = (validatedData: IValidationResult[][]): object[] => {
  if (validatedData == null || validatedData.length === 0) {
    return [];
  }

  const headers = validatedData[0].map((titleCell) => String(titleCell.value));
  const headerLength = headers.length;
  const longestRowLength = validatedData.reduce((acc, row) => (row.length > acc ? row.length : acc), 0);

  // Pad header if it is shorter than the longest row
  if (longestRowLength > headerLength) {
    for (let i = headerLength; i < longestRowLength; i++) {
      headers.push(`Column ${i + 1}`);
    }
  }

  // If header contains empty values, change them to [Column1] [Column2] etc.
  headers.forEach((value, index) => {
    if (value.trim() === "") {
      headers[index] = `Column ${index + 1}`;
    }
  });

  // Change duplicate header values to [header] [header(1)] etc.
  const headerMap = new Map<string, number>();
  const deduplicatedHEaders = headers.reduce((acc, value) => {
    const val = String(value);
    if (headerMap.has(val)) {
      const count = headerMap.get(val);
      headerMap.set(val, count + 1);
      acc.push(`${val}(${count})`);
    } else {
      headerMap.set(val, 1);
      acc.push(val);
    }

    return acc;
  }, []);

  // Create object array from grid data
  const objArr = validatedData.slice(1).map((row) => {
    const rowObject = {
      __validationResult: row,
    };

    for (let i = 0; i < deduplicatedHEaders.length; i++) {
      rowObject[deduplicatedHEaders[i]] = row[i] ?? "";
    }

    return rowObject;
  });

  return objArr;
};


export const pnsParentValidator: IColumnValidator = {
  validate: (value, dataSet, row, col) => {
    if (value == null) {
      return false;
    }

    const val = String(value);

    if (val === "") {
      return false;
    }

    const partCount = val.split(".").length;

    if (partCount === 1) {
      return true;
    }

    // find parent with one less part above current row by iterating backwards
    let parentValue = null;

    for (let i = row - 1; i >= 0; i--) {
      const rowValue = String(dataSet[i][col]);
      const rowPartCount = rowValue.split(".").length;
      if (rowPartCount === partCount - 1) {
        parentValue = rowValue;
        break;
      }
    }

    if (parentValue == null) {
      return false;
    }

    if (val?.startsWith(parentValue)) {
      return true;
    }

    return false;
  },
  errorMessage: "PNS må ha forelder med en del mindre",
};

export const emptyValidator: IColumnValidator = {
  validate: (value) => {
    return value != null && value !== "";
  },
  errorMessage: "Verdien skal ikke være tom",
};

const numberRegex = /^\d+([.,]\d+)?$/;

export const numberValidator: IColumnValidator = {
  validate: (value) => numberRegex.test(String(value)),
  errorMessage: "Verdien skal være et tall",
};


export const geoReportValidation = [
  emptyValidator,
  numberValidator,
  numberValidator,
  numberValidator,
  emptyValidator,
  numberValidator,
  numberValidator,
];
